var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKayak = function SvgKayak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 208 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kayak_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF690F",
    d: "M0 0h39.836v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.28 10.008h4.842v20H12.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.556 29.992h-5.342L16.707 20l5.507-9.992h5.342L22.015 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF690F",
    d: "M42.05 0h39.835v40H42.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m58.357 27.118-.866 2.907h-5.158l6.556-20.05h6.157l6.506 20.05h-5.275l-.865-2.874zm3.527-11.395-2.33 7.469h4.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF690F",
    d: "M84.082 0h39.836v40H84.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M106.496 30.025h-4.875v-8.838l-6.54-11.212h5.758l3.228 6.149 3.178-6.149h5.674l-6.423 11.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF690F",
    d: "M126.131 0h39.836v40h-39.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m142.438 27.118-.865 2.907h-5.158l6.556-20.05h6.156l6.507 20.05h-5.275l-.865-2.874zm3.528-11.395-2.33 7.469h4.659z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF690F",
    d: "M168.164 0H208v40h-39.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M180.444 10.008h4.842v20h-4.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M195.719 29.992h-5.341L184.87 20l5.508-9.992h5.341L190.178 20z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kayak_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h208v40H0z"
  })))));
};
export default SvgKayak;